import { render, staticRenderFns } from "./CardCopy.vue?vue&type=template&id=23c1ed3a"
import script from "./CardCopy.vue?vue&type=script&lang=js"
export * from "./CardCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports